
export default function PottedPlant(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="2em"
      height="2em"
      {...props}
    >
      <g fill="none">
        <path
          fill="#497426"
          d="M16.008 19.236c-.25 0-.45-.2-.45-.45v-1.795a.15.15 0 0 0-.107-.144l-4.15-1.243a.15.15 0 0 1-.1-.187l.174-.582a.15.15 0 0 1 .186-.1l3.803 1.139a.15.15 0 0 0 .193-.144v-.074c0-1 .28-1.99.84-2.83q.207-.311.354-.649a.146.146 0 0 0-.094-.197L11.9 10.554a.15.15 0 0 1-.1-.187l.174-.582a.15.15 0 0 1 .187-.1l4.725 1.417a.146.146 0 0 0 .188-.12q.033-.266.033-.536v-1.95a.15.15 0 0 1 .15-.15h.6a.15.15 0 0 1 .15.15v1.95l-.002.13a.155.155 0 0 0 .197.154l3.53-1.056a.15.15 0 0 1 .187.101l.174.583a.15.15 0 0 1-.1.186l-4.08 1.22a.15.15 0 0 0-.102.105a5.1 5.1 0 0 1-.655 1.427c-.46.7-.7 1.52-.7 2.36v.791c0 .1.097.173.194.144l3.793-1.137a.15.15 0 0 1 .186.101l.175.582a.15.15 0 0 1-.101.187l-4.14 1.24a.15.15 0 0 0-.107.144v1.078c0 .25-.2.45-.45.45"
        ></path>
        <path
          fill="#497426"
          d="M16.008 19.236c-.25 0-.45-.2-.45-.45v-3.13c0-1 .28-1.99.84-2.83c.47-.71.71-1.53.71-2.38v-2.1h.9v2.1c0 1.02-.29 2-.85 2.85c-.46.7-.7 1.52-.7 2.36v3.13c0 .25-.2.45-.45.45"
        ></path>
        <path
          fill="url(#f2091id0)"
          d="M16.008 19.236c-.25 0-.45-.2-.45-.45v-3.13c0-1 .28-1.99.84-2.83c.47-.71.71-1.53.71-2.38v-2.1h.9v2.1c0 1.02-.29 2-.85 2.85c-.46.7-.7 1.52-.7 2.36v3.13c0 .25-.2.45-.45.45"
        ></path>
        <path
          stroke="#497426"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m11.288 15.126l4.84 1.45"
        ></path>
        <path
          stroke="url(#f2091id1)"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m11.288 15.126l4.84 1.45"
        ></path>
        <path
          stroke="#497426"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m11.888 10.076l5.27 1.58"
        ></path>
        <path
          stroke="url(#f2091id2)"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m11.888 10.076l5.27 1.58"
        ></path>
        <path
          stroke="#497426"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m20.717 15.846l-4.84 1.45"
        ></path>
        <path
          stroke="url(#f2091idy)"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m20.717 15.846l-4.84 1.45"
        ></path>
        <path
          stroke="url(#f2091id3)"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m20.717 15.846l-4.84 1.45"
        ></path>
        <path
          stroke="#497426"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m22.007 10.066l-4.75 1.42"
        ></path>
        <path
          stroke="url(#f2091id4)"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m22.007 10.066l-4.75 1.42"
        ></path>
        <path
          stroke="url(#f2091id5)"
          strokeMiterlimit="10"
          strokeWidth=".908"
          d="m22.007 10.066l-4.75 1.42"
        ></path>
        <g filter="url(#f2091idk)">
          <path
            stroke="url(#f2091id6)"
            strokeLinecap="round"
            strokeWidth=".25"
            d="m14.602 10.766l2.71.812"
          ></path>
        </g>
        <g filter="url(#f2091idl)">
          <path
            stroke="url(#f2091id7)"
            strokeLinecap="round"
            strokeWidth=".25"
            d="m13.184 15.594l2.711.812"
          ></path>
        </g>
        <g filter="url(#f2091idm)">
          <path
            stroke="url(#f2091id8)"
            strokeLinecap="round"
            strokeWidth=".25"
            d="m18.513 16.484l-2.711.812"
          ></path>
        </g>
        <g filter="url(#f2091idn)">
          <path
            stroke="url(#f2091id9)"
            strokeLinecap="round"
            strokeWidth=".25"
            d="m19.868 10.624l-2.71.812"
          ></path>
        </g>
        <g filter="url(#f2091ido)">
          <path
            stroke="url(#f2091ida)"
            strokeLinecap="round"
            strokeWidth=".25"
            d="M17.558 8.986v1.662a4 4 0 0 1-.43 1.802l-.572 1.134a5 5 0 0 0-.536 2.252v2.556"
          ></path>
        </g>
        <path
          fill="url(#f2091idz)"
          d="M21.738 19.996a9.25 9.25 0 0 0-5.73-2c-2.15 0-4.14.75-5.73 2z"
        ></path>
        <path
          fill="url(#f2091id10)"
          d="M17.458 2.066a5.104 5.104 0 0 0-.13 7.22c.09.09.24.1.33.01a5.104 5.104 0 0 0 .13-7.22c-.09-.1-.24-.1-.33-.01"
        ></path>
        <g filter="url(#f2091idp)">
          <path
            fill="url(#f2091idb)"
            d="M17.488 2.721c-1.402 1.605-1.443 4.25-.09 5.911c.063.074.166.082.229.009c1.402-1.605 1.443-4.25.09-5.912c-.063-.081-.166-.081-.229-.008"
          ></path>
        </g>
        <g filter="url(#f2091idq)">
          <path
            fill="#7AAD33"
            d="m10.658 11.526l-3.261-.978a.24.24 0 0 0-.303.17a3.737 3.737 0 0 0 2.553 4.398l3.262.979a.24.24 0 0 0 .303-.17a3.716 3.716 0 0 0-2.554-4.399"
          ></path>
          <path
            fill="url(#f2091id11)"
            d="m10.658 11.526l-3.261-.978a.24.24 0 0 0-.303.17a3.737 3.737 0 0 0 2.553 4.398l3.262.979a.24.24 0 0 0 .303-.17a3.716 3.716 0 0 0-2.554-4.399"
          ></path>
        </g>
        <g filter="url(#f2091idr)">
          <path
            fill="#7AAD33"
            d="m12.128 6.736l-3.26-.978a.24.24 0 0 0-.304.172a3.74 3.74 0 0 0 2.563 4.396l3.26.978a.24.24 0 0 0 .304-.17a3.73 3.73 0 0 0-2.564-4.398"
          ></path>
          <path
            fill="url(#f2091id12)"
            d="m12.128 6.736l-3.26-.978a.24.24 0 0 0-.304.172a3.74 3.74 0 0 0 2.563 4.396l3.26.978a.24.24 0 0 0 .304-.17a3.73 3.73 0 0 0-2.564-4.398"
          ></path>
        </g>
        <g filter="url(#f2091ids)">
          <path
            fill="#7AAD33"
            d="m20.538 12.486l3.26-.978a.24.24 0 0 1 .303.17a3.737 3.737 0 0 1-2.553 4.398l-3.262.979a.24.24 0 0 1-.303-.17a3.72 3.72 0 0 1 2.555-4.399"
          ></path>
          <path
            fill="url(#f2091id13)"
            d="m20.538 12.486l3.26-.978a.24.24 0 0 1 .303.17a3.737 3.737 0 0 1-2.553 4.398l-3.262.979a.24.24 0 0 1-.303-.17a3.72 3.72 0 0 1 2.555-4.399"
          ></path>
          <path
            fill="url(#f2091id14)"
            d="m20.538 12.486l3.26-.978a.24.24 0 0 1 .303.17a3.737 3.737 0 0 1-2.553 4.398l-3.262.979a.24.24 0 0 1-.303-.17a3.72 3.72 0 0 1 2.555-4.399"
          ></path>
        </g>
        <g filter="url(#f2091idt)">
          <path
            fill="#7AAD33"
            d="m21.358 6.846l3.26-.978a.24.24 0 0 1 .303.17a3.737 3.737 0 0 1-2.553 4.398l-3.262.979a.24.24 0 0 1-.303-.17a3.71 3.71 0 0 1 2.555-4.399"
          ></path>
          <path
            fill="url(#f2091id15)"
            d="m21.358 6.846l3.26-.978a.24.24 0 0 1 .303.17a3.737 3.737 0 0 1-2.553 4.398l-3.262.979a.24.24 0 0 1-.303-.17a3.71 3.71 0 0 1 2.555-4.399"
          ></path>
          <path
            fill="url(#f2091id16)"
            d="m21.358 6.846l3.26-.978a.24.24 0 0 1 .303.17a3.737 3.737 0 0 1-2.553 4.398l-3.262.979a.24.24 0 0 1-.303-.17a3.71 3.71 0 0 1 2.555-4.399"
          ></path>
        </g>
        <path
          fill="url(#f2091id17)"
          d="m9.007 23.996l.78 4.69c.13.76.78 1.31 1.54 1.31h9.35c.76 0 1.42-.55 1.54-1.31l.79-4.69z"
        ></path>
        <path
          fill="url(#f2091idc)"
          d="m9.007 23.996l.78 4.69c.13.76.78 1.31 1.54 1.31h9.35c.76 0 1.42-.55 1.54-1.31l.79-4.69z"
        ></path>
        <path
          fill="url(#f2091idd)"
          d="m9.007 23.996l.78 4.69c.13.76.78 1.31 1.54 1.31h9.35c.76 0 1.42-.55 1.54-1.31l.79-4.69z"
        ></path>
        <path
          fill="url(#f2091ide)"
          d="m9.007 23.996l.78 4.69c.13.76.78 1.31 1.54 1.31h9.35c.76 0 1.42-.55 1.54-1.31l.79-4.69z"
        ></path>
        <path
          fill="url(#f2091id18)"
          d="M23.507 23.996h-15c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h15c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5"
        ></path>
        <path
          fill="url(#f2091idf)"
          d="M23.507 23.996h-15c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h15c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5"
        ></path>
        <path
          fill="url(#f2091idg)"
          d="M23.507 23.996h-15c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h15c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5"
        ></path>
        <path
          fill="url(#f2091idh)"
          d="M23.507 23.996h-15c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h15c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5"
        ></path>
        <g filter="url(#f2091idu)">
          <path
            stroke="url(#f2091idi)"
            strokeLinecap="round"
            strokeWidth=".4"
            d="M11.052 20.472h12.41"
          ></path>
        </g>
        <g filter="url(#f2091idv)">
          <path
            stroke="url(#f2091idj)"
            strokeLinecap="round"
            strokeWidth=".5"
            d="M17.682 2.799c.475.81 1.245 2.585.504 5.059"
          ></path>
        </g>
        <g filter="url(#f2091idw)">
          <path
            stroke="url(#f2091id19)"
            strokeLinecap="round"
            strokeWidth=".4"
            d="m11.156 6.953l1.106.376c.272.093.539.21.76.394c.492.411 1.118 1.156 1.197 2.105"
          ></path>
        </g>
        <g filter="url(#f2091idx)">
          <path
            stroke="url(#f2091id1a)"
            strokeLinecap="round"
            strokeWidth=".4"
            d="m9.756 11.954l1.106.376c.272.093.539.209.76.393c.492.412 1.118 1.157 1.197 2.106"
          ></path>
        </g>
        <defs>
          <linearGradient
            id="f2091id0"
            x1="17.134"
            x2="17.134"
            y1="8.946"
            y2="9.703"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3F6928"></stop>
            <stop offset="1" stopColor="#3F6928" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091id1"
            x1="12.969"
            x2="13.198"
            y1="16.309"
            y2="15.721"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A5B3B"></stop>
            <stop offset="1" stopColor="#4A5B3B" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091id2"
            x1="13.826"
            x2="14.104"
            y1="11.457"
            y2="10.69"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A5B3B"></stop>
            <stop offset="1" stopColor="#4A5B3B" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091id3"
            x1="17.393"
            x2="17.273"
            y1="17.445"
            y2="17.076"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A5B3B"></stop>
            <stop offset="1" stopColor="#4A5B3B" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091id4"
            x1="18.807"
            x2="18.628"
            y1="11.636"
            y2="11.271"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A5B3B"></stop>
            <stop offset="1" stopColor="#4A5B3B" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091id5"
            x1="19.076"
            x2="18.349"
            y1="11.148"
            y2="11.346"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A5B3B"></stop>
            <stop offset="1" stopColor="#4A5B3B" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091id6"
            x1="15.133"
            x2="17.836"
            y1="10.898"
            y2="11.828"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#608246"></stop>
            <stop offset="1" stopColor="#608246" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091id7"
            x1="13.716"
            x2="18.05"
            y1="15.726"
            y2="16.907"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#648746"></stop>
            <stop offset="1" stopColor="#648746" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091id8"
            x1="17.982"
            x2="13.647"
            y1="16.616"
            y2="17.797"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#648746"></stop>
            <stop offset="1" stopColor="#648746" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091id9"
            x1="19.337"
            x2="15.003"
            y1="10.757"
            y2="11.937"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#648746"></stop>
            <stop offset="1" stopColor="#648746" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091ida"
            x1="17.237"
            x2="17.237"
            y1="10.766"
            y2="19.236"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#608246"></stop>
            <stop offset="1" stopColor="#728C5B"></stop>
          </linearGradient>
          <linearGradient
            id="f2091idb"
            x1="17.558"
            x2="17.558"
            y1="2.667"
            y2="8.692"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9CD740"></stop>
            <stop offset="1" stopColor="#9CD740" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091idc"
            x1="8.469"
            x2="13.031"
            y1="27.281"
            y2="26.996"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B17A60"></stop>
            <stop offset="1" stopColor="#B17A60" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091idd"
            x1="16.007"
            x2="16.007"
            y1="28.688"
            y2="30.313"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".011" stopColor="#D37082" stopOpacity="0"></stop>
            <stop offset="1" stopColor="#D37082"></stop>
          </linearGradient>
          <linearGradient
            id="f2091ide"
            x1="16.007"
            x2="16.007"
            y1="23.924"
            y2="24.489"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C87156"></stop>
            <stop offset="1" stopColor="#C87156" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091idf"
            x1="7.5"
            x2="17"
            y1="23.996"
            y2="23.996"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#AE7F61"></stop>
            <stop offset="1" stopColor="#AE7F61" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091idg"
            x1="16.007"
            x2="16.007"
            y1="23.547"
            y2="23.996"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D1556C" stopOpacity="0"></stop>
            <stop offset="1" stopColor="#D37082"></stop>
            <stop offset="1" stopColor="#D1556C"></stop>
          </linearGradient>
          <linearGradient
            id="f2091idh"
            x1="16.007"
            x2="16.007"
            y1="19.675"
            y2="20.317"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E6AB68"></stop>
            <stop offset="1" stopColor="#E6AB68" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091idi"
            x1="24.132"
            x2="11.583"
            y1="20.39"
            y2="20.39"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCD08F" stopOpacity="0"></stop>
            <stop offset=".287" stopColor="#FFCD91"></stop>
            <stop offset=".795" stopColor="#FCD08F" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="f2091idj"
            x1="18.325"
            x2="18.325"
            y1="2.533"
            y2="9.577"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B9EE6E"></stop>
            <stop offset="1" stopColor="#B9EE6E" stopOpacity="0"></stop>
          </linearGradient>
          <filter
            id="f2091idk"
            width="3.461"
            height="1.563"
            x="14.226"
            y="10.391"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".125"
            ></feGaussianBlur>
          </filter>
          <filter
            id="f2091idl"
            width="3.461"
            height="1.563"
            x="12.809"
            y="15.219"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".125"
            ></feGaussianBlur>
          </filter>
          <filter
            id="f2091idm"
            width="3.461"
            height="1.563"
            x="15.427"
            y="16.109"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".125"
            ></feGaussianBlur>
          </filter>
          <filter
            id="f2091idn"
            width="3.461"
            height="1.563"
            x="16.782"
            y="10.249"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".125"
            ></feGaussianBlur>
          </filter>
          <filter
            id="f2091ido"
            width="2.287"
            height="10.156"
            x="15.645"
            y="8.611"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".125"
            ></feGaussianBlur>
          </filter>
          <filter
            id="f2091idp"
            width="4.296"
            height="8.025"
            x="15.409"
            y="1.667"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".5"
            ></feGaussianBlur>
          </filter>
          <filter
            id="f2091idq"
            width="6.309"
            height="5.568"
            x="7"
            y="10.538"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset></feOffset>
            <feGaussianBlur stdDeviation=".125"></feGaussianBlur>
            <feComposite
              in2="hardAlpha"
              k2="-1"
              k3="1"
              operator="arithmetic"
            ></feComposite>
            <feColorMatrix values="0 0 0 0 0.713726 0 0 0 0 0.784314 0 0 0 0 0.647059 0 0 0 1 0"></feColorMatrix>
            <feBlend
              in2="shape"
              result="effect1_innerShadow_28327_7581"
            ></feBlend>
          </filter>
          <filter
            id="f2091idr"
            width="6.311"
            height="5.567"
            x="8.474"
            y="5.748"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset></feOffset>
            <feGaussianBlur stdDeviation=".125"></feGaussianBlur>
            <feComposite
              in2="hardAlpha"
              k2="-1"
              k3="1"
              operator="arithmetic"
            ></feComposite>
            <feColorMatrix values="0 0 0 0 0.713726 0 0 0 0 0.784314 0 0 0 0 0.647059 0 0 0 1 0"></feColorMatrix>
            <feBlend
              in2="shape"
              result="effect1_innerShadow_28327_7581"
            ></feBlend>
          </filter>
          <filter
            id="f2091ids"
            width="6.309"
            height="5.568"
            x="17.886"
            y="11.498"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset></feOffset>
            <feGaussianBlur stdDeviation=".125"></feGaussianBlur>
            <feComposite
              in2="hardAlpha"
              k2="-1"
              k3="1"
              operator="arithmetic"
            ></feComposite>
            <feColorMatrix values="0 0 0 0 0.713726 0 0 0 0 0.784314 0 0 0 0 0.647059 0 0 0 1 0"></feColorMatrix>
            <feBlend
              in2="shape"
              result="effect1_innerShadow_28327_7581"
            ></feBlend>
          </filter>
          <filter
            id="f2091idt"
            width="6.309"
            height="5.568"
            x="18.706"
            y="5.858"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset></feOffset>
            <feGaussianBlur stdDeviation=".125"></feGaussianBlur>
            <feComposite
              in2="hardAlpha"
              k2="-1"
              k3="1"
              operator="arithmetic"
            ></feComposite>
            <feColorMatrix values="0 0 0 0 0.713726 0 0 0 0 0.784314 0 0 0 0 0.647059 0 0 0 1 0"></feColorMatrix>
            <feBlend
              in2="shape"
              result="effect1_innerShadow_28327_7581"
            ></feBlend>
          </filter>
          <filter
            id="f2091idu"
            width="13.411"
            height="1"
            x="10.552"
            y="19.972"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".15"
            ></feGaussianBlur>
          </filter>
          <filter
            id="f2091idv"
            width="2.512"
            height="6.759"
            x="16.832"
            y="1.949"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".3"
            ></feGaussianBlur>
          </filter>
          <filter
            id="f2091idw"
            width="4.263"
            height="4.075"
            x="10.556"
            y="6.353"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".2"
            ></feGaussianBlur>
          </filter>
          <filter
            id="f2091idx"
            width="4.263"
            height="4.075"
            x="9.156"
            y="11.354"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feGaussianBlur
              result="effect1_foregroundBlur_28327_7581"
              stdDeviation=".2"
            ></feGaussianBlur>
          </filter>
          <radialGradient
            id="f2091idy"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(163.277 7.903 9.818)scale(1.2153 1.86926)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A5B3B"></stop>
            <stop offset="1" stopColor="#4A5B3B" stopOpacity="0"></stop>
          </radialGradient>
          <radialGradient
            id="f2091idz"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(0 -2.3759 9.50361 0 14.6 20.22)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#774336"></stop>
            <stop offset="1" stopColor="#714F4A"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id10"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-2.45976 0 0 -6.95372 18.654 5.68)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A5D949"></stop>
            <stop offset="1" stopColor="#80B93F"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id11"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(-150.851 8.79 5.076)scale(9.94444 3.64933)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#AAE057"></stop>
            <stop offset="1" stopColor="#AAE057" stopOpacity="0"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id12"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-8.6875 -4.84375 1.77725 -3.1876 15.469 9)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#AAE057"></stop>
            <stop offset="1" stopColor="#AAE057" stopOpacity="0"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id13"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(139.185 9.802 10.385)scale(8.09043 3.57458)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#AAE057"></stop>
            <stop offset="1" stopColor="#AAE057" stopOpacity="0"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id14"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-1.24899 1.88738 -.4373 -.2894 24.195 11.251)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ACE461"></stop>
            <stop offset="1" stopColor="#ACE461" stopOpacity="0"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id15"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(139.185 11.261 7.718)scale(8.09043 3.57458)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#AAE057"></stop>
            <stop offset="1" stopColor="#AAE057" stopOpacity="0"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id16"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-1.24899 1.88738 -.4373 -.2894 25.015 5.612)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ACE461"></stop>
            <stop offset="1" stopColor="#ACE461" stopOpacity="0"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id17"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(-140.346 15.876 10.732)scale(8.03669 7.80374)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".171" stopColor="#FFBB7A"></stop>
            <stop offset="1" stopColor="#CF7D5B"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id18"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-5.24257 -5.68749 4.40502 -4.06042 21.25 23.063)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".313" stopColor="#FFBD80"></stop>
            <stop offset="1" stopColor="#E09369"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id19"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-.5625 .64062 -114.12824 -100.21118 13.36 8.016)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B3E468"></stop>
            <stop offset="1" stopColor="#B3E468" stopOpacity="0"></stop>
          </radialGradient>
          <radialGradient
            id="f2091id1a"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(-.5625 .64062 -114.12824 -100.21118 11.96 13.016)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B3E468"></stop>
            <stop offset="1" stopColor="#B3E468" stopOpacity="0"></stop>
          </radialGradient>
        </defs>
      </g>
    </svg>
  )
}

